/**
 * Profile Image
 */
export const ProfileImage = (function () {

  var fileImage;
  /**
   * Registers the event handlers for the upload and save functionality
   */
  var init = function () {

    //Gets name of file when clicking upload and displays it
    $('input[type="file"]').change(function (e) {
      fileImage = e.target.files;
      
      //Get size of image
      var imgSize = fileImage[0].size / 1024 / 1024;

      if(imgSize > 1) {
        Util.toggleAlert('#myds-alert-profile', 'Image size is too large, please select an image smaller than 1MB', 'alert');
        return;
      }
      
      if(fileImage.length > 0) {
        var reader = new FileReader();
        reader.onload = function(e) {
          $('#imgToCrop').attr('src', reader.result);
          $('#imgModal').modal({
            backdrop: 'static',
            keyboard: false,
            show: true
          });
        }
        reader.readAsDataURL(fileImage[0]);
      }
      
    });

    $('.cancel').on('click', function(e) {
      e.preventDefault();
      $('#imgModal').modal('hide');
      $('input[type="file"]').val('');
    });

    //open modal and display cropper
    $('#imgModal').on('shown.bs.modal', function() {
      cropImage($('#imgToCrop'));
    }).on('hidden.bs.modal', function () {
      $('#imgToCrop').cropper('destroy');
    });
    
    $('.crop').on('click', function(e) {
      e.preventDefault();
      var fileName = fileImage[0].name;

      if (fileImage.length > 0) {
        //Get the cropped image
        var croppedCanvas = $('#imgToCrop').cropper('getCroppedCanvas');
        //Check if is an image - null if no value is found
        if(croppedCanvas == null) {
          $('#imgModal').modal('hide');
          Util.toggleAlert('#myds-alert-profile', 'File selected is not an image', 'alert');
          return;
        }
        croppedCanvas.toBlob(function(blob) {
        //send it in the ajax request usind loadFile()
          var formData = new FormData();
          formData.append('myds-profile-picture', blob, fileName);
          loadFile(formData);
        }, fileImage[0].type, 0.99);
      }
    });

  }
  
  /**
   * Loads the file
   * @param {*} profileImage cropped image
   */
  var loadFile = function (profileImage) {
    var url = $('#myds-profile-image').attr('action');
    var csrf = Util.getCSRF();

    $.ajax({
      type: 'POST',
      url: url,
      headers: {
        'isAPI': true,
        'x-csrf-token': csrf
      },
      cache: false,
      contentType: false,
      processData: false,
      data: profileImage
    }).done(function (response) {
      $('#imgModal').modal('hide');
      Util.toggleAlert('#myds-alert-profile', 'Image uploaded succesfully', 'alert');
      //update image in img tag
      $('#myds-imageID').attr("src", response.transaction.var_value);
      
    }).fail(function (err) {
      var error = err.responseJSON.message;
      $('#imgModal').modal('hide');
      Util.toggleAlert('#myds-alert-profile', error, 'alert');
      
    })
  };

  /**
   * Function that enables the cropper and sets the allowed size for the cropper
   * @param {*} image 
   */
  var cropImage = function(image) {
    image.cropper({
      aspectRatio: 12 / 9,
      viewMode: 3
    });
  }

  return {
    init: init
  }

}());